import React from "react";
import "./Footer.comp.css";

export const Footer = () => {
  return (
    <>
      <div id="footer" className="text-center copy-right">
        &copy; Incosa Ticketing System 2023
      </div>
    </>
  );
};
